import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { DomainConfig } from 'src/app/config/domain.config';

@Injectable({
  providedIn: 'root'
})
export class CorporateGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    if (DomainConfig.isCorporate === true) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
  
}
